(() => {
  const root = document;
  const form = root.querySelector('[data-os-cart-form]');
  if (!form) return;

  const updateLine = async (line, qty) => {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      location.reload();
    } catch (e) {
      location.reload();
    }
  };

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-os-qty]');
    if (!btn) return;

    e.preventDefault();
    const line = parseInt(btn.getAttribute('data-line'), 10);
    const delta = parseInt(btn.getAttribute('data-delta'), 10);

    const input = root.querySelector(`[data-os-qty-input][data-line="${line}"]`);
    const current = input ? parseInt(input.value || '1', 10) : 1;
    const next = Math.max(0, current + delta);

    updateLine(line, next);
  });

  root.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-os-remove]');
    if (!rm) return;

    e.preventDefault();
    const line = parseInt(rm.getAttribute('data-line'), 10);
    updateLine(line, 0);
  });
})();

